var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4112 1.70188C18.1991 1.19344 16.9859 1 15.7734 1C11.9244 0.999688 8.07562 2.94812 4.22656 2.94812C3.26125 2.94812 2.29656 2.82563 1.33125 2.51938C1.22281 2.485 1.11406 2.46875 1.00781 2.46875C0.47 2.46875 0 2.885 0 3.46281V13.3772C0 13.7719 0.225938 14.1459 0.58875 14.2978C1.80094 14.8066 3.01406 15 4.22656 15C8.07562 15 11.9247 13.0516 15.7738 13.0516C16.7391 13.0516 17.7037 13.1741 18.6691 13.4803C18.7775 13.5147 18.8862 13.5309 18.9925 13.5309C19.5303 13.5309 20.0003 13.1147 20.0003 12.5369V2.62281C20 2.22781 19.7741 1.85406 19.4112 1.70188ZM1.5 4.13188C2.12875 4.28938 2.785 4.36844 3.46 4.41094C3.27625 5.32937 2.46875 6.02156 1.5 6.02156V4.13188ZM1.5 13.0381V11.545C2.57406 11.545 3.44313 12.3972 3.49094 13.4637C2.78688 13.4072 2.12875 13.2666 1.5 13.0381ZM10 11C8.61906 11 7.5 9.65656 7.5 8C7.5 6.34312 8.61938 5 10 5C11.3806 5 12.5 6.34312 12.5 8C12.5 9.65719 11.3803 11 10 11ZM18.5 11.8681C17.9525 11.7309 17.3841 11.6541 16.8025 11.6044C16.9859 10.7894 17.6619 10.1706 18.5 10.0644V11.8681ZM18.5 4.48969C17.5347 4.3675 16.7856 3.56156 16.7559 2.56625C17.3666 2.63406 17.9463 2.76094 18.5 2.96187V4.48969Z",
    fill: "#53B175"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.0358a4e6532538a9f2cca9ca25df21a9.svg";
export { ForwardRef as ReactComponent };